import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit, Renderer2 } from '@angular/core'

import { ITrack, TracksTypes } from '../../../Interface/track'
import { RoutingPathService } from '../../../services/environment.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { ShareTrackPopupService } from '../../../services/share-track-popup.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-share-track-popup',
  templateUrl: './bmcore-share-track-popup.component.html',
  styleUrls: ['./bmcore-share-track-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreShareTrackPopupComponent implements OnInit {
  @Input() colorSettingsMode = false
  @Input() appType: AppType

  @Input() showVerificationIcon = false

  lg: LgType
  isPopupOpen = false
  track: ITrack
  url: string
  isCopiedToClipboard = false
  shareTrackLink = ''

  constructor(
    private shareTrackPopupService: ShareTrackPopupService,
    public routingPathService: RoutingPathService,
    private i18nService: I18nService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    // path from url
    this.url = window.location.origin

    this.shareTrackPopupService.isShareTrackPopupOpenSubject.subscribe(track => {
      this.track = track
      this.isPopupOpen = true
      this.shareTrackLink = this.setShareTrackLink(track.type)
    })
  }

  setShareTrackLink(trackType: TracksTypes) {
    let pageUrl: string

    switch (trackType) {
      case 'beat':
        pageUrl = this.routingPathService.getBeatPageUrl(this.track.id)
        break
      case 'free-beat':
        pageUrl = this.routingPathService.getFreeBeatPageUrl(this.track.id)
        break
    }

    return `${this.url}/${pageUrl.substring(1)}`
  }

  closePopup() {
    /* No parent scroll on modal scroll */
    this.renderer.removeClass(document.body, 'modal-open')

    this.isCopiedToClipboard = false
    this.isPopupOpen = false
  }

  copyInputMessage(inputElement: HTMLInputElement) {
    this.isCopiedToClipboard = true
    this.enableCopiedToClipboardBtn()

    // https://stackoverflow.com/questions/49102724/angular-5-copy-to-clipboard
    inputElement.select()
    document.execCommand('copy')
    inputElement.setSelectionRange(0, 0)
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closePopup()
    }
  }

  enableCopiedToClipboardBtn() {
    setTimeout(() => {
      this.isCopiedToClipboard = false
    }, 5000)
  }
}
